import { Box, Button, Typography } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ResourceListResourceType } from '../ResourceList';
import { NoResultsContainer } from './NoResultsContainer';

export interface ErrorStateProps {
  onRetry?: () => void;
  resourceType: ResourceListResourceType;
}

const errorStateMessages: { [key in ResourceListResourceType]: { text: string } } = {
  Alert: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Alerts.',
      id: '10+F1M',
    }),
  },
  Dashboard: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Dashboards.',
      id: 'zkH9iI',
    }),
  },
  Funnel: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Funnels.',
      id: 'mu5/ss',
    }),
  },
  Heatmap: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Heatmaps.',
      id: 'LmU79U',
    }),
  },
  Segment: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Segments.',
      id: 'N57ycZ',
    }),
  },
  Metric: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Metrics.',
      id: 'sPX4ry',
    }),
  },
  Journey: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Journeys.',
      id: 'aTaCac',
    }),
  },
  Page: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Pages.',
      id: 'qvG+3r',
    }),
  },
  Retention: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Retention.',
      id: '4kuFrU',
    }),
  },
  Space: {
    text: intl.formatMessage({
      defaultMessage: 'Oops... There was a problem loading your Space.',
      id: '60z/NH',
    }),
  },
};

export const ErrorState: React.FC<ErrorStateProps> = ({ onRetry, resourceType }) => (
  <NoResultsContainer data-component="ErrorState">
    <Box paddingBottom={16}>
      <Typography variant="body1">{errorStateMessages[resourceType].text}</Typography>
    </Box>
    {onRetry ? (
      <Box paddingBottom={40}>
        <Button variant="fill-primary" onClick={onRetry}>
          <FormattedMessage
            defaultMessage="Try again?"
            id="2f/GMw"
            description="Try again button. Displayed when there was an error loading data."
          />
        </Button>
      </Box>
    ) : null}
  </NoResultsContainer>
);
